<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content" style="padding-bottom: 6rem;">
            <limitless-card-tabs-view :links="routes" type="buttons">
                <div class="card">
                    <div class="card-body">
                        {{ deliveryGroup }}
                    </div>
                </div>
            </limitless-card-tabs-view>
        </div>
    </div>
</template>

<script>
import LimitlessCardTabsView from '@components/Limitless/CardTabsView';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';

export default {
    name: 'DeliveryCenter',
    props: {
        deliveryGroup: {
            type: String,
            default: null,
        },
    },
    components: {
        LimitlessCardTabsView,
        LimitlessPageHeader,
    },
    data: () => ({
        osdf: null,
    }),
    methods: {

    },
    computed: {
        routes() {
            return [
                { name: 'deliverycenter', params: { deliveryGroup: 'se' }, text: 'Sverige' },
                { name: 'deliverycenter', params: { deliveryGroup: 'fi' }, text: 'Finland' },
            ];
        },
    },
};
</script>
